import {
  RewardAmountBurstSvg,
  RewardHeartArrowSvg,
} from './tip-reward-claim-screen.styles';

const rewardBurstDots = [
  {
    className: 'reward-burst-dot reward-burst-dot--one',
    d: 'M3.23391 67.6037C1.36614 67.5917 0.0182055 66.2516 7.1751e-05 64.3863C-0.0120174 62.5271 1.50517 60.9999 3.31855 61.0421C5.1561 61.0904 6.65515 62.6478 6.60074 64.4587C6.54634 66.2154 5.04728 67.6158 3.23391 67.6037Z',
    fill: '#FFA31D',
  },
  {
    className: 'reward-burst-dot reward-burst-dot--two',
    d: 'M51.7906 27.4006C49.9228 27.3885 48.5748 26.0484 48.5567 24.1832C48.5446 22.324 50.0618 20.7967 51.8752 20.839C53.7127 20.8873 55.2118 22.4447 55.1574 24.2556C55.103 26.0122 53.6039 27.4127 51.7906 27.4006Z',
    fill: '#FFA31D',
  },
  {
    className: 'reward-burst-dot reward-burst-dot--three',
    d: 'M55.0894 77.1479C53.2216 77.1358 51.8737 75.7958 51.8555 73.9305C51.8435 72.0713 53.3606 70.5441 55.174 70.5863C57.0116 70.6346 58.5106 72.192 58.4562 74.0029C58.4018 75.7595 56.9028 77.16 55.0894 77.1479Z',
    fill: '#FFA31D',
  },
] as const;

const rewardBurstTrails = [
  {
    className: 'reward-burst-trail reward-burst-trail--one',
    d: 'M98.7565 72.622C99.6952 66.5584 97.6724 65.4333 92.688 69.2467C88.2989 73.5344 86.5736 72.6464 87.5124 66.5828C88.9254 59.9239 87.1397 58.5012 82.1553 62.3146C77.2919 67.1975 75.5667 66.3095 76.9796 59.6506',
    stroke: '#FF8800',
  },
  {
    className: 'reward-burst-trail reward-burst-trail--two',
    d: 'M27.954 22.9952C29.8453 16.4116 27.7631 14.8814 21.7072 18.4047C16.2439 22.5368 14.458 21.311 16.3493 14.7274C18.8495 7.55112 17.0716 5.72463 11.0157 9.24791C4.94364 13.9726 3.15768 12.7469 5.65785 5.57061',
    stroke: '#FF8800',
  },
  {
    className: 'reward-burst-trail reward-burst-trail--three',
    d: 'M78.9297 7.41079C72.3359 6.808 70.6546 9.03753 73.8857 14.0994C77.9034 18.6373 76.5884 20.9004 69.9406 20.8884C63.2928 20.8765 61.6115 23.1061 64.8966 27.577C68.1276 32.6389 66.4463 34.8684 59.8525 34.2656',
    stroke: '#FB6712',
  },
  {
    className: 'reward-burst-trail reward-burst-trail--four',
    d: 'M38.5549 57.8605C39.0157 62.2371 37.5494 63.3749 34.1558 61.2739C31.1033 58.6452 29.6113 59.5399 29.68 63.9577C29.7487 68.3756 28.2823 69.5134 25.281 67.371C21.8874 65.27 20.4211 66.4078 20.882 70.7844',
    stroke: '#FB6712',
  },
] as const;

const rewardHeartArrowDots = [
  {
    className: 'reward-heart-dot reward-heart-dot--one',
    d: 'M53.5513 29.0083C51.6835 28.9962 50.3356 27.6561 50.3174 25.7908C50.3053 23.9316 51.8225 22.4044 53.6359 22.4467C55.4735 22.4949 56.9725 24.0524 56.9181 25.8633C56.8637 27.6199 55.3646 29.0203 53.5513 29.0083Z',
    fill: '#FFA31D',
  },
  {
    className: 'reward-heart-dot reward-heart-dot--two',
    d: 'M17.5903 75.8618C15.7226 75.8497 14.3746 74.5096 14.3565 72.6444C14.3444 70.7851 15.8616 69.2579 17.675 69.3002C19.5125 69.3485 21.0116 70.9059 20.9572 72.7168C20.9028 74.4734 19.4037 75.8739 17.5903 75.8618Z',
    fill: '#FFA31D',
  },
] as const;

const rewardHeartArrowTrails = [
  {
    className: 'reward-heart-trail reward-heart-trail--one',
    d: 'M105.898 47.1077C100.669 43.8975 98.8492 45.328 100.439 51.3992C102.696 57.1048 101.21 58.3525 95.981 55.1423C90.3863 51.2646 88.3838 52.3613 89.9734 58.4325C92.5962 64.8056 91.1102 66.0533 85.5156 62.1756',
    stroke: '#FF8800',
    strokeWidth: '3.61827',
  },
  {
    className: 'reward-heart-trail reward-heart-trail--two',
    d: 'M25.7342 22.9952C27.6256 16.4116 25.5433 14.8814 19.4874 18.4047C14.0242 22.5368 12.2382 21.311 14.1296 14.7274C16.6297 7.55112 14.8519 5.72463 8.79599 9.24791C2.72389 13.9726 0.937931 12.7469 3.4381 5.57061',
    stroke: '#FF8800',
    strokeWidth: '3.61827',
  },
  {
    className: 'reward-heart-main',
    d: 'M37.0126 72.016C28.5838 61.4475 10.2637 47.2872 25.2845 32.2664C33.9429 23.6081 42.7795 34.1683 47.2097 41.1989C49.2239 44.3952 50.8482 47.6639 52.5286 51.0246C53.1054 52.1782 53.7789 55.5888 54.3557 54.4352C55.2351 52.6766 54.809 49.1984 55.4519 47.1268C56.3413 44.2612 57.7076 41.7241 59.634 39.4124C63.0998 35.2534 71.3918 27.8549 77.3771 32.51C85.0911 38.5096 78.9623 55.6362 75.1034 62.5151C71.836 68.3395 67.5284 74.4751 62.8009 79.2026C62.2387 79.7648 58.4337 84.33 59.8776 81.0297C61.0636 78.3189 62.3949 75.0242 62.3949 72.016C62.3949 69.0744 59.8105 77.3028 58.4159 79.8928C55.6617 85.0079 63.7016 81.8011 66.78 81.8011',
    stroke: '#FFBE00',
    strokeWidth: '4',
  },
] as const;

export function RewardAmountBurst() {
  return (
    <RewardAmountBurstSvg>
      {rewardBurstDots.map(dot => (
        <path
          className={dot.className}
          d={dot.d}
          fill={dot.fill}
          key={dot.className}
        />
      ))}
      {rewardBurstTrails.map(trail => (
        <path
          className={trail.className}
          d={trail.d}
          fill="none"
          key={trail.className}
          pathLength="1"
          stroke={trail.stroke}
          strokeLinecap="round"
          strokeWidth="3.61827"
        />
      ))}
    </RewardAmountBurstSvg>
  );
}

export function RewardHeartArrowGraphic() {
  return (
    <RewardHeartArrowSvg>
      {rewardHeartArrowDots.map(dot => (
        <path className={dot.className} d={dot.d} fill={dot.fill} key={dot.d} />
      ))}
      {rewardHeartArrowTrails.map(trail => (
        <path
          className={trail.className}
          d={trail.d}
          fill="none"
          key={trail.d}
          pathLength="1"
          stroke={trail.stroke}
          strokeLinecap="round"
          strokeWidth={trail.strokeWidth}
        />
      ))}
    </RewardHeartArrowSvg>
  );
}
